import Event from '../../core/Event';

export default class EstimationProductsSearchRequested extends Event {
    public static type = 'EstimationProductsSearchRequested';

    constructor(public readonly query: string) {
        super(EstimationProductsSearchRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/estimations/events/EstimationProductsSearchRequested.ts